import React from 'react'
import PropTypes from 'prop-types'
import BaseIcon from '../../BaseIcon/BaseIcon'
import { ReactComponent as Component } from './Instagram.svg'

const Instagram = ({ className }) => {
	return <BaseIcon component={Component} className={className} viewBox="0 0 448 512" />
}

Instagram.propTypes = {
	className: PropTypes.string,
}

export default Instagram
